import { vars } from "@common/styles";
import { ReleaseMetricScore } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { CopyAction } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl.styles";
import styled from "styled-components";

export const EndpointList = styled.div`
  display: grid;
  grid-template-columns: max-content max-content max-content 1fr;
  row-gap: 1rem;
  align-items: center;
`;

export const EndpointRow = styled.div`
  display: contents;

  &:hover ${CopyAction} {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const EndpointScore = styled(ReleaseMetricScore)`
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  border-radius: 0.6rem;

  p {
    font-weight: 600;
    font-size: 11.2px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
  }
`;

export const MethodBadge = styled.span`
  border: 2px solid ${vars.colors.grey90};
  border-radius: 2rem;
  padding: 0.3rem 1rem;
  font-size: 1.4rem;
  color: ${vars.colors.grey30};
  white-space: nowrap;
  font-family: Roobert, serif;
  text-align: center;
  letter-spacing: 0.02em;
  line-height: 1.8rem;
`;

export const WarningIconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  img {
    width: 3.2rem;
    height: 3.2rem;
  }
`;

export const ErrorIconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  margin-left: -0.5rem;

  img {
    width: 3.2rem;
    height: 3.2rem;
  }
`;
